import Vue from 'vue';
import VueRouter from 'vue-router';
import Login from '../views/Login.vue';
import Recover from '../views/Recover.vue';

const isAutenthicated = () => {
  const jwt = localStorage.getItem('jwtToken');
  const user = localStorage.getItem('user');
  return (jwt && user);
};

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'login',
    component: Login,
  },
  {
    path: '/forget',
    name: 'login.recover',
    component: Recover,
  },
  {
    path: '/app',
    name: 'auth.dashboard',
    component: () => import(/* webpackChunkName: "home" */ '../views/Dashboard.vue'),
    children: [
      {
        path: 'property/:propertyId',
        name: 'auth.property',
        component: () => import(/* webpackChunkName: "about" */ '../views/Property.vue'),
      },
      {
        path: 'maps/:propertyId',
        name: 'auth.property.map',
        component: () => import(/* webpackChunkName: "about" */ '../views/PropertyMap.vue'),
      },
      {
        path: 'photos/:propertyId',
        name: 'auth.property.photos',
        component: () => import(/* webpackChunkName: "about" */ '../views/PropertyPhotos.vue'),
      },
    ],
  },
  {
    path: '/about',
    name: 'app.about',
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue'),
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    let position = { x: 0, y: 0 };
    if (savedPosition) position = savedPosition;
    return new Promise((resolve) => {
      setTimeout(() => resolve(position), 1000);
    });
  },
});

router.beforeEach((to, from, next) => {
  if (to.name.indexOf('auth.') === 0 && !isAutenthicated()) next({ name: 'login' });
  else if (to.name.indexOf('login') === 0 && isAutenthicated()) next({ name: 'auth.dashboard' });
  else next();
});

export default router;
